import { Col } from 'antd';
import { InputComponent } from 'components/common/Input';
import { LABEL_TYPE } from 'components/common/Input/types';
import styled from 'styled-components';

export const ControlledInputStyled = styled(InputComponent)`
  display: flex;
  width: 100%;
  min-height: 36px;
`;

export const SideFieldContainerColStyled = styled(Col)``;

export const DataOuterContainerStyled = styled.div<{ labelType?: LABEL_TYPE }>`
  display: flex;
  flex-flow: ${({ labelType }) => (labelType === LABEL_TYPE.above || labelType === LABEL_TYPE.under ? 'column' : 'row')}
    nowrap;
`;

export const DataContainerStyled = styled.div`
  display: flex;
  flex-flow: row nowrap;
  max-width: 100%;
  & > span {
    width: 100%;
  }
`;

export const LabelStyled = styled(Col)<{
  $labelType?: LABEL_TYPE;
  $marginHorizontal?: string;
  $marginVertical?: string;
}>`
  font-weight: 500;
  font-size: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  margin-${({ $labelType }) => {
    switch ($labelType) {
      case LABEL_TYPE.above:
        return 'bottom';
      case LABEL_TYPE.left:
        return 'right';
      case LABEL_TYPE.under:
        return 'top';
      case LABEL_TYPE.right:
        return 'left';
      default:
        return 'right';
    }
  }}: ${({ $labelType, $marginHorizontal, $marginVertical }) => {
  switch ($labelType) {
    case LABEL_TYPE.above:
    case LABEL_TYPE.under:
      return $marginVertical || '5';
    case LABEL_TYPE.left:
    case LABEL_TYPE.right:
      return $marginHorizontal || '10';
    default:
      return $marginHorizontal || '10';
  }
}}px;
  order: ${({ $labelType }) => {
    switch ($labelType) {
      case LABEL_TYPE.above:
      case LABEL_TYPE.left:
        return 0;
      case LABEL_TYPE.under:
      case LABEL_TYPE.right:
        return 1;
      default:
        return 0;
    }
  }};
`;
